/**
 * @file paddle Wave Summit 2020 图文卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useEffect, useMemo, useState} from 'react';
import {Row} from 'antd';
import moment, {Moment} from 'moment';

import LiveCard from './LiveCard';

import {ILiveCard, ILiveCardItem} from './types';


const getLiveState = (now: Moment, startTime?: Moment, endTime?: Moment): 'before' | 'current' | 'after' => {
    if (startTime && now.isBefore(startTime)) {
        return 'before';
    }
    else if (endTime && now.isAfter(endTime)) {
        return 'after';
    }
    return 'current';
};


const LiveCardGroup: React.FC<ILiveCard> = props => {
    const [now, setNow] = useState<Moment>(() => {
        return moment();
    });

    useEffect(() => {
        const h = setInterval(() => {
            setNow(moment());
        }, 2000);
        return () => {
            clearInterval(h);
        };
    }, [setNow]);

    const {
        topList,
        list
    } = props;

    const sortTopList = useMemo(() => {
        return (topList ?? []).sort((a, b) => {
            if (a.startTime && b.startTime) {
                return a.startTime.unix() - b.startTime.unix();
            }
            return 0;
        });
    }, [topList]);
    const sortList = useMemo(() => {
        return (list ?? []).sort((a, b) => {
            if (a.startTime && b.startTime) {
                return a.startTime.unix() - b.startTime.unix();
            }
            return 0;
        });
    }, [list]);

    const theList = useMemo<ILiveCardItem[]>(() => {
        const newList = sortTopList.concat(sortList).filter(live => {
            return live.endTime?.isAfter(now);
        });
        const newListMap = new Map<string, ILiveCardItem>();
        newList.forEach(l => {
            newListMap.set(l.key || '', l);
        });
        const newList2 = Array.from(newListMap.values());
        const newList3 = newList2.slice(0, 4);

        return newList3.map((live) => {
            return {
                ...live,
                liveState: getLiveState(now, live.startTime, live.endTime)
            };
        });
    }, [now, sortList, sortTopList]);

    return (
        <Row className="paddle-live-live-card-group" gutter={[13, 13]}>
            {theList.map(item => (
                <LiveCard
                    key={item.key}
                    {...item}
                />
            ))}
        </Row>
    );
};

export default LiveCardGroup;
